import { createDate, importAll, transformImages } from "utils";

import GalleryComponent from "components/Media/Gallery";
import QuibblerMain from "../../_hp-quibbler-main";
import QuibblerMakingOf from "../../_hp-quibbler-making-of";
import ReplicaBigTitle from "components/Replicas/ReplicaBigTitle";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import { ReplicaVersionType } from "types";
import background from "./background.jpg";
import thumbnail from "./thumbnail.png";

let gallery = [];
let galleryArticles = [];

try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/)
  );
  galleryArticles = importAll(
    (require as any).context("./gallery-articles", false, /\.(png|jpe?g|svg)$/)
  );
} catch (e) {
  console.log(e);
}

/* VERSION DATA */
export const VERSION_DATA: ReplicaVersionType = {
  isWIP: false,
  page: undefined,
  dateCreated: createDate({ day: 1, month: 5, year: 2025 }),
  datePublished: createDate({ day: 1, month: 7, year: 2025 }),
  version: "1",
  isSeries: false,
  thumbnail,
  background,
};

/* VERSION PAGE */
const Page = () => {
  return (
    <ReplicaContent>
      <QuibblerMain
        gallery={transformImages(gallery)}
        galleryImageOptions={[
          { index: 0, aspectRatio: 1.5 },
          { index: 5, aspectRatio: 1.5 },
          { index: 7, aspectRatio: 1.5 },
          { index: 10, aspectRatio: 1.5 },
        ]}
        video={"https://youtu.be/gRb2DZ1Wbmw"}
      />

      <ReplicaBigTitle title="The very first issue!" />
      <ReplicaParagraph>
        This issue marks the beginning of The Quibbler. Since I wasn’t able to
        find any pages that had been designed for this issue, I had complete
        creative freedom to come up with my own content. As you may have noticed
        from looking at the other issues of The Quibbler, the design gradually
        evolved throughout the films and the overall design process. That’s a
        natural progression — and something that happens in real life too —
        which is why I chose to base the interior layout on the front cover. I
        made it slightly different from the rest of the issues, while still
        keeping the overall design “vocabulary” consistent enough to make it
        believable that later issues evolved from this one. Naturally, The
        Quibbler made its debut with a bang, packed with plenty of absurd
        theories and wild ideas about the “truth” behind what’s really happening
        in the wizarding world.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <GalleryComponent
        images={transformImages(galleryArticles)}
        imagesPerRow={3}
        imageOptions={[{ index: 0, aspectRatio: 2 }]}
        imageMaxHeight="250px"
      />
      <ReplicaSpacer />

      <QuibblerMakingOf />
    </ReplicaContent>
  );
};

export default {
  ...VERSION_DATA,
  page: <Page />,
} as ReplicaVersionType;
